import { environment } from '../../../../environments/environment';

export const corporate = [
  {
    id: environment.stripePrices.corporate1LicenseMonthly,
    name: '1 Carbon Footprint License',
    price: '€97',
    duration: 'month',
    type: 'subscription',
    licenses: 1,
    logoIncluded: true,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '1 License',
      'Reports upon request: €250 each + VAT',
      'Dedicated tutor available separately',
    ],
  },
  {
    id: environment.stripePrices.corporate1LicenseYearly,
    name: '1 Carbon Footprint License',
    price: '€997',
    duration: 'year',
    type: 'subscription',
    licenses: 1,
    logoIncluded: true,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '1 License',
      'Reports upon request: €250 each + VAT',
      'Dedicated tutor available separately',
    ],
  },
  {
    id: environment.stripePrices.corporate2LicensesMonthly,
    name: '2 Carbon Footprint Licenses',
    price: '€197',
    duration: 'month',
    type: 'subscription',
    licenses: 2,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      'Reports included',
      'Carbon Manager Training Course included',
      'Dedicated tutor available separately',
    ],
  },
  {
    id: environment.stripePrices.corporate2LicensesYearly,
    name: '2 Carbon Footprint Licenses',
    price: '€1,997',
    duration: 'year',
    type: 'subscription',
    licenses: 2,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      'Reports included',
      'Carbon Manager Training Course included',
      'Dedicated tutor available separately',
    ],
  },
];

export const corporateIT = [
  {
    id: environment.stripePrices.corporate1LicenseMonthly,
    name: '1 Carbon Footprint License',
    price: '€97',
    duration: 'mese',
    type: 'subscription',
    licenses: 1,
    logoIncluded: true,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '1 Licenza',
      'Report su richiesta: €250 ciascuno + IVA',
      'Tutor dedicato disponibile separatamente',
    ],
  },
  {
    id: environment.stripePrices.corporate1LicenseYearly,
    name: '1 Carbon Footprint License',
    price: '€997',
    duration: 'anno',
    type: 'subscription',
    licenses: 1,
    logoIncluded: true,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '1 Licenza',
      'Report su richiesta: €250 ciascuno + IVA',
      'Tutor dedicato disponibile separatamente',
    ],
  },
  {
    id: environment.stripePrices.corporate2LicensesMonthly,
    name: '2 Carbon Footprint Licenses',
    price: '€197',
    duration: 'mese',
    type: 'subscription',
    licenses: 2,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      'Report inclusi',
      'Corso di formazione Carbon Manager incluso',
      'Tutor dedicato disponibile separatamente',
    ],
  },
  {
    id: environment.stripePrices.corporate2LicensesYearly,
    name: '2 Carbon Footprint Licenses',
    price: '€1,997',
    duration: 'anno',
    type: 'subscription',
    licenses: 2,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      'Report inclusi',
      'Corso di formazione Carbon Manager incluso',
      'Tutor dedicato disponibile separatamente',
    ],
  },
];
